<template>
    <div>

        <b-modal
      id="modalInfo"
      v-model="isOpen"
      class="modalInfo"
      style="padding: 30px"
      :title="$t('label_evaluation_auditRecords_uploadRecord')"
    >
      <b-col class="col-h8" cols="12">
              <div>
                {{$t('label_evaluation_auditRecords_category')}}
              </div>
              <b-form-select
                id="modelabel_evaluation_administrator_node_matrix_indicator"
                v-model="currentCategory"
                style="width: 100%"
              >
                <option
                  v-for="(category, optionIndex) of categories"
                  :key="optionIndex"
                  :value="optionIndex"
                >
                  {{ $t(category.name) }}
                </option>
              </b-form-select>
          </b-col>
      <b-form-group
        style="margin-top: 15px"
        id="file"
        :label="$t('label_evaluation_auditRecords_message')"
        label-for="file"
      >
        <b-form-file
          v-if="currentCategory == 2"
          accept="image/*"
          v-model="file"
          :state="Boolean(file)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
        <b-form-file
          v-else
          v-model="file"
          :state="Boolean(file)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>
      <b-form-group
        id="title"
        :label="$t('label_evaluation_auditRecords_modal_titleDescription')"
        label-for="title"
      >
        <b-input-group>
          <b-input id="title" v-model="title" />
        </b-input-group>
      </b-form-group>

      <div slot="modal-footer" class="w-100" style="text-align: center">
        <b-row class="d-flex justify-content-center">
          <b-col cols="4">
            <b-btn @click="isOpen = false">
              {{$t("label_evaluation_auditRecords_cancel")}}
            </b-btn>
          </b-col>
          <b-col cols="4">
            <b-btn variant="primary" :disabled="file == null || title == null || title == ''" @click="loadFile()">
              {{ $t("label_evaluation_auditRecords_uploadFile") }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";

export default {
  name: "UploadRecordModal",
  props: {
    categories: {
      type: Array,
      default: ()=>[],
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title : '',
      file: null,
      evaluationId: this.$route.params.idEvaluation,
      currentCategory: {},
    };
  },
  computed: {
    ...mapGetters(["getUserAccount"]),

    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.file = null;
        this.title = null;
        this.$emit("update:showModal", newValue);
      },
    },
  },
  methods: {
    createFormData() {
      var username = this.$store.getters.getUserAccount.username
      var userId = this.$store.getters.getUserAccount.id
      const data = new FormData();
      data.append("file", this.file, this.file.name)
      data.append("title", this.title)
      data.append("name", this.file.name)
      data.append("account", username)
      data.append("accountId", userId)
      data.append("date", new Date().toLocaleDateString("en-US"))
      data.append("category", this.currentCategory)
      data.append("evaluationId", this.evaluationId);
      return data;
    },

    processFile: async function () {
      const data = this.createFormData();
      await axiosCall({ url: "Records/uploadRecord/" + this.evaluationId, method: "POST", data,
      headers: {
            "Content-Type": "multipart/form-data",
          }}).then((response) =>{
          this.$emit("reload")
          this.isOpen = false;
        });
    },
    loadFile: async function(){
      var username = this.getUserAccount.username
      if (this.file !== null) {
        await this.processFile()
      }
    },
  }
}
</script>
